/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const REMOVE_VEHICLE_TOOLTIP = {
    id: 'remove_vehicle_tooltip',
    message: (
        <FormattedMessage
            id='remove_vehicle_tooltip'
            defaultMessage='Убрать эту машину из выбранной для сражений техники.'
        />
    ),
}

export const VEHICLE_NOT_READY = (
    <FormattedMessage
        id='vehicle_not_ready'
        defaultMessage='Не готова к бою'
    />
)

export const TIME_TO_BATTLES_START = value => (
    <FormattedMessage
        id='time_to_battles_start'
        defaultMessage='До начала сражений: {value}'
        values = {{ value }}
    />
)

export const TIME_TO_BATTLES_END = value => (
    <FormattedMessage
        id='time_to_battles_end'
        defaultMessage='До завершения сражений: {value}'
        values = {{ value }}
    />
)

export const FIGHT_IN_SORTIES_BY_LEVEL = level => (
    <FormattedMessage
        id='players_matching.fight_in_sorties_by_level'
        defaultMessage='Сражаться легионером в режиме Вылазки {level}'
        values = {{ level }}
    />
)

export const PLAYERS_MATCHING_AVAILABLE_ONLY_ON_THIS_BATTLEMODE = (
    <FormattedMessage
        id='players_matching_available_only_on_this_battle_mode'
        defaultMessage='Автоматический подбор отряда доступен только в этом режиме.'
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/constants.js